module.exports = function () {
  return {
    restrict: "EA",
    replace: true,
    template: require("raw!templates/header.html"),
    controller: controller,
  };
};

function controller($scope, $state, store, $window, contentful) {
  contentful.entries("content_type=specialsPage").then(function (res) {
    // console.log('specials', res);
    $scope.specials = res.data.items[0];
  });
  contentful.entries("content_type=popUp").then(function (res) {
    $scope.pop = res.data.items[0];
    console.log("Pop", $scope.pop);
  });
}



// WEBPACK FOOTER //
// ./components/directives/header.js